import classBlock from './classblock.directive';
import plannerCourseCard from './plannercoursecard.directive';
import recentSearchCard from './recentsearchcard.directive';
import searchResult from './searchresult.directive';
import searchResultRow from './searchresultrow.directive';

const moduleName = 'usc.timetable.directives';

angular.module(moduleName, [])
    .directive('classBlock', ['timetableService', 'plannerFactory', '$uibModal', classBlock])
    .directive('plannerCourseCard', ['$filter', 'timetableService', 'plannerFactory', '$uibModal', plannerCourseCard])
    .directive('recentSearchCard', ['timetableService', 'recentSearchesFactory', recentSearchCard])
    .directive('searchResult', ['$filter', '$sce', '$rootScope', searchResult])
    .directive('searchResultRow', ['plannerFactory', searchResultRow]);

export default moduleName;